import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large SubmitOrders",
    title: "Выдача всех заказов",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.submitOrders
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        value: _ctx.state.type,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.type) = $event)),
        "is-invalid": _ctx.state_form$.type.$error,
        "validation-errors": _ctx.state_form$.type.$errors,
        placeholder: "Выберите на что выдать заказы",
        options: _ctx.SubmitOrdersTypes,
        "select-by": "api_key"
      }, null, 8, ["value", "is-invalid", "validation-errors", "options"]),
      (_ctx.state.type === _ctx.DispatcherSubmitOrdersTypesEnum.onsector)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_the_select, {
              class: "mt-3",
              "is-invalid": _ctx.state_form$.sector.$error,
              "validation-errors": _ctx.state_form$.sector.$errors,
              value: _ctx.state.sector,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.sector) = $event)),
              placeholder: "Выберите сектор",
              options: _ctx.sectors_state.list,
              loading: _ctx.sectors_state.is_loading,
              failed: _ctx.sectors_state.is_failed,
              onRefresh: _ctx.loadSectors
            }, null, 8, ["is-invalid", "validation-errors", "value", "options", "loading", "failed", "onRefresh"]),
            _createVNode(_component_the_select, {
              class: "mt-3",
              "is-invalid": _ctx.state_form$.courier.$error,
              "validation-errors": _ctx.state_form$.courier.$errors,
              value: _ctx.state.courier,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.courier) = $event)),
              placeholder: "Выберите курьера",
              label: "fullName",
              "search-by": "fullName",
              options: _ctx.couriers_state.list,
              loading: _ctx.couriers_state.is_loading,
              failed: _ctx.couriers_state.is_failed,
              "error-text": "При получении списка курьеров произошла ошибка",
              "infinite-scroll": "",
              onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadCouriers(_ctx.couriers_state.pagination.current_page))),
              onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreCouriers(_ctx.couriers_state.pagination.current_page + 1))),
              onSearch: _ctx.searchCourier,
              onOptionBySearch: _ctx.unshiftFindedCourier
            }, null, 8, ["is-invalid", "validation-errors", "value", "options", "loading", "failed", "onSearch", "onOptionBySearch"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}